// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2d8Ll","item":"PaymentsMobile_item__crGCJ","label":"PaymentsMobile_label__PnId8","amount":"PaymentsMobile_amount__33Keq"};